import { Fragment } from "react";

import Property6Img from "../../../assets/images/property6.png";
import Property4Img from "../../../assets/images/property4.png";
import Property7Img from "../../../assets/images/property7.png";
import Property5Img from "../../../assets/images/property5.png";
import WhyChooseImg from "../../../assets/images/why-choose.png";

import "./PropertyGallery.css";
import { useStaticPageContent } from "../../../hooks/useStaticPageContent";
import { staticContentDefaults } from "../../../data/staticContentDefaults";
import { getStaticContentImage } from "../../../utils/staticContentImages";
import CmsRichText from "../../common/CmsRichText";
import { mergeGalleryHeadingHtml } from "../../../utils/cmsHeadingUtils";

const defaultGalleryImages = [
  Property6Img,
  Property4Img,
  Property7Img,
  Property5Img,
  WhyChooseImg,
  Property6Img,
  Property4Img,
];
const galleryItemClasses = ["item1", "item2", "item3", "item4", "item5", "item6", "item7"];

const PropertyGallery = () => {
  const pageContent = useStaticPageContent("home");
  const content =
    pageContent?.propertyGallery ||
    staticContentDefaults.home.propertyGallery;
  const headingParts =
    content?.headingParts ||
    staticContentDefaults.home.propertyGallery.headingParts;
  const galleryImages = content?.galleryImages?.length
    ? content.galleryImages
    : staticContentDefaults.home.propertyGallery.galleryImages;

  return (
    <Fragment>
      <div className="property-gallery">
        <div className="container-fluid my-container">
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="heading-sec">
                <h2>
                  <CmsRichText
                    as="span"
                    value={mergeGalleryHeadingHtml(headingParts, content?.headingHtml)}
                  />
                </h2>
                <a href={content.ctaLink}>
                  <CmsRichText as="span" value={content.ctaText} />
                </a>
              </div>
            </div>
            <div className="col-12 col-lg-12">
              <div className="grid-outlet">
                <div className="grid-container">
                  {galleryImages.map((image, index) => (
                    <div className={galleryItemClasses[index]} key={`${image}-${index}`}>
                      <img
                        src={getStaticContentImage(
                          image,
                          defaultGalleryImages[index]
                        )}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PropertyGallery;
